import { SET_NY_REBATE } from './constants';

const defaultState = {
    nyRebate: 0.30,
};

const nyserda = (state = defaultState, action) => {
    switch (action.type) {
        case SET_NY_REBATE:
            return { ...state, nyRebate: action.nyRebate };

        default:
            return state;
    }
};

export default nyserda;



// WEBPACK FOOTER //
// ./src/containers/common/nyserda/reducer.js